export class PaymentContractError extends Error {
  override name = 'PaymentContractError';
}
